import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class ObfuscatedLink extends Base {
  static config = {
    name: 'ObfuscatedLink',
  };

  /**
   * @param {object} root0
   * @param {Event} root0.event
   */
  onClick({ event }) {
    const url = this.$el.dataset.href;
    if (!url) return;

    const openInNewTab = event.metaKey || event.ctrlKey || event.button === 1;

    queueMicrotask(() => {
      if (event.defaultPrevented) return;

      if (openInNewTab) {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    });
  }

  /**
   * @param {object} root0
   * @param {KeyboardEvent} root0.event
   */
  onKeydown({ event }) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onClick({ event });
    }
  }
}
